<!--
 * @Author: your name
 * @Date: 2020-12-30 10:15:37
 * @LastEditTime: 2021-01-21 11:56:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\MeasurComp\MesureComp.vue
-->
<template>
  <!--measure button-->
  <div id="measure">
    <div class="measure-button-container" v-if="isShowMeasureIcon">
      <div class="measure-icon-box" @click="showMeasureButton">
        <img ref="measureIcon" :src="measureButtonIcon" class="measure-icon" />
      </div>
      <div
        class="measure-clear-icon-box"
        v-show="measureButton"
        @click="clearMeasureData"
      >
        <img
          ref="measureClearIcon"
          :src="measureClearButtonIcon"
          alt=""
          class="measure-clear-icon"
        />
      </div>
    </div>
    <!--measure canvas container-->
    <div class="measure-canvas-container" v-show="measureButton">
      <canvas id="measure-canvas"></canvas>
      <div class="measurement-button-container">
        <span
          :class="item.active ? 'measurement-item-active' : 'measurement-item'"
          v-for="(item, index) in measurement"
          :key="'measure-' + index"
          @click="changeMeasurement(index)"
          >{{ item.name }}</span
        >
      </div>
      <div class="confirm-recall-button-container" v-if="measureOperationBox">
        <div class="confirm-button-box" @click="confirmMeasure">
          <img :src="measureConfirmButtonIcon" class="confirm-button-icon" />
        </div>
        <div class="recall-button-box" @click="recallMeasureHistory">
          <img :src="measureRecallButtonIcon" class="recall-button" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Measure } from "@/components/modeldemo/Measure";
import { getPlatform } from "@/components/modeldemo/Utils";
import { Events } from "@/components/modeldemo/Events";
import * as Statistic from '../Statistic'
export default {
  name: "modelMeasure",
  components: {},
  props: {},
  data() {
    return {
      measureOperationBox: false,
      measureButton: false,
      isShowMeasureIcon: false,
      measurement: [
        {
          name: "m",
          active: true,
        },
        {
          name: "ft",
          active: false,
        },
      ],
      measureButtonIcon: require("@/assets/img/icon/measure_button.png"),
      measureClearButtonIcon: require("@/assets/img/icon/measure_clear.png"),
      measureConfirmButtonIcon: require("@/assets/img/icon/measure-icon-sure.png"),
      measureRecallButtonIcon: require("@/assets/img/icon/measure-icon-recall.png"),
    };
  },
  methods: {
    init(control) {
      this._measure = new Measure(getPlatform(), control.camera);
      this.ctrl = control;

      const measureCanvas = document.createElement("canvas");
      let ctx = measureCanvas.getContext("2d");
      measureCanvas.id = "measure-canvas";
      document
        .getElementsByClassName("measure-canvas-container")[0]
        .appendChild(measureCanvas);

      control.events.on(Events.To2D, this.modelShowMeasureButton);
      control.events.on(Events.To3D, this.modelHideMeasureButton);
      control.events.on(Events.ToPano, this.modelHideMeasureButton);
      this._measure.startPaintListener.add(this.showOperation.bind(this));
      this._measure.endPaintListener.add(this.hideOperation.bind(this));
    },
    //测量按钮的显示和隐藏
    showMeasureButton() {
      this.measureButton = !this.measureButton;
      if (this.measureButton) {
        Statistic.markInteract(Statistic.InteractType.Measure);

        this.initMeasureCanvas();
        this.$refs.measureIcon.src = require("@/assets/img/icon/measure_exit.png");
        this.isSwitchReturnLink = false;
        this.isShowLogo = false;
        this.ctrl.breakDamping();
        this._measure.init();
        this.ctrl.events.on(Events.Update, this.update);
        this.$emit(Events.MeasureOn);
      } else {
        this.$refs.measureIcon.src = require("@/assets/img/icon/measure_button.png");
        this.isSwitchReturnLink = true;
        this.isShowLogo = true;
        this._measure.exit();
        this.ctrl.events.removeListener(Events.Update, this.update);
        this.$emit(Events.MeasureClose);
      }
    },

    update() {
      if (this._measure.measureMode) this._measure.update();
    },

    hideMeasureButton() {},
    // out use function
    modelShowMeasureButton() {
      if(!this._measure.showMeasure) return; // 如果checkbox为false则不显示
      this.isShowMeasureIcon = true;
    },
    modelHideMeasureButton() {
      if (!this.isShowMeasureIcon) return;
      this.isShowMeasureIcon = false;
    },
    //initCanvas
    initMeasureCanvas() {
      let measureCanvasContainer = document.querySelector("#model-show");
      let canvasWidth = parseInt(
        document.defaultView
          .getComputedStyle(measureCanvasContainer, null)
          .width.split("px")[0]
      );
      let canvasHeight = parseInt(
        document.defaultView
          .getComputedStyle(measureCanvasContainer, null)
          .height.split("px")[0]
      );
      let measureCanvas = document.querySelector("#measure-canvas");
      measureCanvas.setAttribute("width", canvasWidth);
      measureCanvas.setAttribute("height", canvasHeight);
    },
    // clear measure canvas
    clearMeasureData() {
      this._measure.clean();
    },
    //click change measurement
    changeMeasurement(index) {
      this.measurement.forEach((value, key) => {
        if (key === index) {
          value.active = true;
          this._measure.changeUnit(index);
        } else {
          value.active = false;
        }
      });
    },
    // recall mesure history
    recallMeasureHistory() {
      this._measure.undo();
    },
    // confirm measure
    confirmMeasure() {
      this._measure.confirm();
    },

    showOperation() {
      this.measureOperationBox = true;
    },
    hideOperation() {
      this.measureOperationBox = false;
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style scoped>
/* measure container */

.measure-button-container {
  width: fit-content;
  height: 40px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 12px;
  right: 100px;
  z-index: 99999999;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.measure-button-container .measure-icon-box,
.measure-button-container .measure-clear-icon-box {
  width: 35px;
  height: 35px;
  object-fit: cover;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin: 0 0 0 15px;
}

.measure-icon-box .measure-icon,
.measure-clear-icon-box .measure-clear-icon {
  width: 16px;
  height: 16px;
  object-fit: cover;
}

.measure-canvas-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
}

.measurement-button-container {
  width: fit-content;
  height: 30px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 10px;
  z-index: 99999;
  border-radius: 4px;
  color: #000;
  background-color: #fff;
}

.measurement-button-container .measurement-item,
.measurement-button-container .measurement-item-active {
  width: 60px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.measurement-button-container .measurement-item-active:nth-child(1) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.measurement-button-container .measurement-item-active:nth-child(2) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.measurement-button-container .measurement-item-active {
  background-color: #40cdd4;
  color: #fff;
}

.confirm-recall-button-container {
  width: 72px;
  height: fit-content;
  position: absolute;
  bottom: 50px;
  left: calc(50% - 36px);
  z-index: 99999;
  display: flex;
  align-items: center;
}

.confirm-recall-button-container div {
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -ms-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.confirm-recall-button-container div:nth-child(1) {
  margin: 0 10px 0 0;
}

.confirm-recall-button-container img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  vertical-align: middle;
}
</style>